/**
 * Construye {@link UppKonvaGroup} (API `model/`) enlazado a {@link UppKonvaFloorPlanGroup} (operaciones en pantalla del stage).
 * English comment normalized.
 */

import type { UppKonvaArea } from '../../model/upp-konva-area';
import { UppKonvaGroup, type UppKonvaGroupStageDelegate } from '../../model/upp-konva-group';
import type { UppKonvaFloorPlanModel } from '../internal/upp-konva-floor-plan-model';
import type { UppKonvaFloorPlanGroup } from '../presentation/upp-konva-floor-plan-group';

/**
 * English comment normalized.
 */
export function createPublicGroupForArea(floorGroup: UppKonvaFloorPlanGroup, area: UppKonvaArea): UppKonvaGroup {
  const delegate: UppKonvaGroupStageDelegate = {
    align: (axis) => {
      floorGroup.align(axis);
    },
    distribute: (axis) => {
      floorGroup.distribute(axis);
    },
    applyUniformGeometry: (widthCm, heightCm, rotationDeg) => {
      return floorGroup.applyUniformGeometry(widthCm, heightCm, rotationDeg);
    },
  };
  const out = new UppKonvaGroup(delegate);
  const shapes = floorGroup.selection
    .map((h) => area.findShapeById(h.uuid))
    .filter((s): s is NonNullable<typeof s> => s != null);
  out.selection = shapes;
  return out;
}

/**
 * English comment normalized.
 * English comment normalized.
 */
export function installUppKonvaGroupedBridgeToArea(floorPlan: UppKonvaFloorPlanModel, area: UppKonvaArea): void {
  floorPlan.chainOnGrouped((g) => {
    if (g) {
      area.notifyGrouped(createPublicGroupForArea(g, area));
    } else {
      area.notifyGrouped(null);
    }
  });
}
